var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-slider-wrapper" },
    [
      _c(
        "swiper",
        {
          ref: "swiper",
          staticClass: "home-slider",
          attrs: { options: _vm.sliderSettings }
        },
        _vm._l(_vm.slides, function(item, index) {
          return _c("swiper-slide", { key: index }, [
            _c(
              "div",
              {
                staticClass: "item",
                class: { load: item.iframeSrc, "empty-link": !item.buttonText }
              },
              [
                _c(
                  "div",
                  { staticClass: "item__box" },
                  [
                    _c(
                      "div",
                      { staticClass: "item__content" },
                      [
                        _c("h2", {
                          domProps: { textContent: _vm._s(item.title) }
                        }),
                        _c("p", {
                          domProps: { innerHTML: _vm._s(item.description) }
                        }),
                        item.buttonText
                          ? _c("router-link", {
                              staticClass: "link",
                              attrs: { to: item.buttonLink },
                              domProps: {
                                textContent: _vm._s(item.buttonText)
                              },
                              nativeOn: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.trackButtonClick(item.buttonLink)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    item.iframeSrc
                      ? _c("div", { staticClass: "item__iframe" }, [
                          _c("iframe", {
                            attrs: {
                              "data-src": item.iframeSrc,
                              title: item.title,
                              frameborder: "0",
                              height: "100%",
                              scrolling: "no",
                              width: "100%"
                            }
                          })
                        ])
                      : _c("div", { staticClass: "item__image" }, [
                          _c(
                            "picture",
                            [
                              _vm._l(
                                (_vm.isDeviceMobile
                                  ? item.mobileImage
                                  : item.desktopImage
                                ).sourcesTypes,
                                function(sourceType, index) {
                                  return _c("source", {
                                    key: index,
                                    attrs: {
                                      "data-srcset": (_vm.isDeviceMobile
                                        ? item.mobileImage
                                        : item.desktopImage)[sourceType],
                                      type: "image/" + sourceType
                                    }
                                  })
                                }
                              ),
                              _c("img", {
                                attrs: {
                                  "data-src": (_vm.isDeviceMobile
                                    ? item.mobileImage
                                    : item.desktopImage
                                  ).jpg,
                                  alt: item.title
                                }
                              })
                            ],
                            2
                          )
                        ]),
                    item.buttonText
                      ? _c("router-link", {
                          staticClass: "linkMobal",
                          attrs: { to: item.buttonLink },
                          domProps: { textContent: _vm._s(item.buttonText) }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        }),
        1
      ),
      _c("div", {
        staticClass: "swiper-button-next swiper-button-white",
        attrs: { id: "button-next-relacionados" },
        on: {
          click: function($event) {
            return _vm.swiperNext()
          }
        }
      }),
      _c("div", {
        staticClass: "swiper-button-prev swiper-button-white",
        attrs: { id: "button-prev-relacionados" },
        on: {
          click: function($event) {
            return _vm.swiperPrev()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }